// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__3jMWy","path":"style_path__3derR","arrow":"style_arrow__2TLWW"};